export const getBar = (chart, tooltipModel) => {
  const dataPoints = tooltipModel.dataPoints,
    datasetIndex = chart.data.datasets.length - 1,
    datasetMeta = chart.getDatasetMeta(datasetIndex),
    scaleBottom = chart.scales['y-axis-0'].bottom,
    bar = datasetMeta.data[dataPoints[0].index]._model,
    canvasPosition = chart.canvas.getBoundingClientRect(),
    paddingLeft = parseFloat(getComputedStyle(chart.canvas).paddingLeft),
    paddingTop = parseFloat(getComputedStyle(chart.canvas).paddingTop),
    scrollLeft = document.body.scrollLeft,
    scrollTop = document.body.scrollTop;

  const result = {
    top: bar.y + canvasPosition.top + paddingTop + scrollTop,
    left:
      bar.x - bar.width / 2 + canvasPosition.left + paddingLeft + scrollLeft,
    width: bar.width,
    height: scaleBottom - bar.y
  };
  result.centerX = result.left + bar.width / 2;
  return result;
};
